export default "__VITE_ASSET__BJeaLn2H__"